<template>
    <!-- @mousemove="readedMessage()" -->
    <div class="chat-box" @click="closeRefBox()">
        <el-container>
            <el-header height="50px">
                <img v-if="activeAccount.channelName == 'customer'" :src="normalizeUrl(`${baseUrl}${cicadeStore.activeChat?.avatar || findChatById(cicadeStore.activeChat?.chatId).avatar}`)" style="height: 30px; width: 30px;margin-right: 12px;"/>
                <span v-if="cicadeStore.activeChat.userType == 'guest'">{{ cicadeStore.activeChat?.chatId }}</span>
                <span v-else>{{ cicadeStore.activeChat?.title }}</span>
                <span title="群聊信息" v-show="this.chat.type == 'GROUP'" class="btn-side el-icon-more" @click="showSide = !showSide"></span>
            </el-header>
            <el-main style="padding: 0" v-loading="loading" ref="chatMain">
                <el-container>
                    <el-container class="content-box">
                        <el-main class="im-chat-main" id="chatScrollBox" @scroll="onScroll">
                            <div class="im-chat-box" ref="chatBox">
                                <ul>
                                    <li v-for="(msgInfo, idx) in cicadeStore.chatHistory" :key="idx">
                                        <chat-message-item
                                            v-if="idx >= showMinIdx && msgInfo.platform == 'customer'"
                                            @call="onCall(msgInfo.type)"
                                            :mine="msgInfo.senderId != msgInfo.chatId"
                                            :showName="msgInfo.title || '-'"
                                            :msgInfo="msgInfo"
                                            :groupMembers="groupMembers"
                                            @delete="deleteMessage"
                                            @recall="recallMessage"
                                        />
                                        <chat-message-item
                                            v-else-if="idx >= showMinIdx && msgInfo.platform == 'facebook_api'"
                                            @call="onCall(msgInfo.type)"
                                            :mine="msgInfo.senderId != (msgInfo.chatIdStr?msgInfo.chatIdStr:msgInfo.chatId)"
                                            :showName="msgInfo.title || '-'"
                                            :msgInfo="msgInfo"
                                            :groupMembers="groupMembers"
                                            @delete="deleteMessage"
                                            @recall="recallMessage"
                                        />
                                        <chat-message-item
                                            v-else-if="idx >= showMinIdx"
                                            @call="onCall(msgInfo.type)"
                                            :mine="msgInfo.senderId == activeAccount[cicadeStore.sendIdKey]"
                                            :showName="msgInfo.title || '-'"
                                            :msgInfo="msgInfo"
                                            @delete="deleteMessage"
                                            @recall="recallMessage"
                                        />
                                    </li>
                                </ul>
                            </div>

                            <div class="chat-bottom-tip" v-show="showBottomTip" @click="scrollToBottom">
                                <el-badge value="new" class="item" :hidden="!isHaveNewMessage">
                                    <span class="el-icon-caret-bottom"></span>
                                </el-badge>
                            </div>
                        </el-main>
                        <el-footer height="220px" class="im-chat-footer">
                            <div class="chat-tool-bar">
                                <!-- <div title="表情" class="icon iconfont icon-emoji" ref="emotion" @click.stop="showEmotionBox()"></div> -->
                                <div title="发送文件">
                                    <file-upload ref="fileUpload" :action="'/file/upload/part'" show-loading :maxSize="10 * 1024 * 1024" @before="onFileBefore" @success="onFileSuccess" @fail="onFileFail">
                                        <!-- <i class="el-icon-wallet"></i> -->
                                        <img style="width: 30px;height: 30px;padding: 3px;box-sizing: border-box;" src="../../assets/image/words.png" alt="">
                                    </file-upload>
                                </div>
                                <div title="聊天记录" @click="showHistoryBox()">
                                    <img style="width: 30px;height: 30px;padding: 3px;box-sizing: border-box;" src="../../assets/image/message.png" alt="">
                                </div>

                                <!-- <div title="聊天设置" class="el-icon-setting" @click="showSettingBox()"></div> -->
                                <div style="width: fit-content; position: absolute; right: 10px;">
                                    <span style="font-size: 14px;margin-right: 5px;">自动翻译</span>
                                    <el-switch @change="changeAutoTranslate" :value="activeAccount.channelName == 'customer'?findChatStatusById(cicadeStore.activeChat?.chatId)?.autoTranslate:cicadeStore.activeChat?.autoTranslate"></el-switch>
                                </div>
                            </div>
                            <div class="send-content-area">
                                <ChatInput :ownerId="group.ownerId" ref="chatInputEditor" :group-members="groupMembers" @submit="sendMessage" />
                                <div class="send-btn-area">
                                    <!-- <el-button type="primary" icon="el-icon-s-promotion" :disabled="activeAccount.status === 0" @click="notifySend()">{{ activeAccount.status === 0 ? '账号已离线' : '发送' }}</el-button> -->
                                    <el-button type="primary" icon="el-icon-s-promotion" @click="notifySend()">发送</el-button>
                                </div>
                            </div>
                        </el-footer>
                    </el-container>
                    <el-aside class="chat-group-side-box" width="260px" v-if="showSide">
                        <chat-group-side :group="group" :groupMembers="groupMembers" @reload="loadGroup(group.id)"> </chat-group-side>
                    </el-aside>
                </el-container>
            </el-main>
            <emotion ref="emoBox" @emotion="onEmotion"></emotion>
            <chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
            <group-member-selector ref="rtcSel" :groupId="group.id" @complete="onInviteOk"></group-member-selector>
            <rtc-group-join ref="rtcJoin" :groupId="group.id"></rtc-group-join>
            <chat-history :visible="showHistory" :chat="chat" :friend="friend" :group="group" :groupMembers="groupMembers" @close="closeHistoryBox"></chat-history>
            <chat-setting :visible="showChatSetting" :account="activeAccount" :chat="chat" @close="showChatSetting = false"></chat-setting>
        </el-container>
    </div>
</template>

<script>
    import ChatGroupSide from './ChatGroupSide.vue';
    import ChatMessageItem from './ChatMessageItem.vue';
    import FileUpload from '../common/FileUpload.vue';
    import Emotion from '../common/Emotion.vue';
    import ChatRecord from './ChatRecord.vue';
    import ChatHistory from './ChatHistory.vue';
    import ChatAtBox from './ChatAtBox.vue';
    import GroupMemberSelector from '../group/GroupMemberSelector.vue';
    import RtcGroupJoin from '../rtc/RtcGroupJoin.vue';
    import ChatInput from './ChatInput';
    import ChatSetting from './ChatSetting.vue';
    import { normalizeUrl } from "@/utils/index";

    export default {
        name: 'chatPrivate',
        components: {
            ChatInput,
            ChatMessageItem,
            FileUpload,
            ChatGroupSide,
            Emotion,
            ChatRecord,
            ChatHistory,
            ChatAtBox,
            ChatSetting,
            GroupMemberSelector,
            RtcGroupJoin
        },
        props: {
            chat: {
                type: Object
            }
        },
        data() {
            return {
                baseUrl: process.env.VUE_APP_BASE_URL,
                friend: {},
                group: {},
                showBottomTip: false,
                isHaveNewMessage: false,
                groupMembers: [],
                sendImageUrl: '',
                sendImageFile: '',
                placeholder: '',
                isReceipt: true,
                showRecord: false, // 是否显示语音录制弹窗
                showSide: false, // 是否显示群聊信息栏
                showHistory: false, // 是否显示历史聊天记录
                lockMessage: false, // 是否锁定发送，
                showMinIdx: 0, // 下标低于showMinIdx的消息不显示，否则页面会很卡置
                reqQueue: [],
                isSending: false,
                loading: false,
			    loadingImg: null,
                showChatSetting: false,
                isLoadingHistory: false, // 是否正在加载历史消息
                oldScrollHeight: null, // 加载历史消息前的滚动高度
                oldHistoryLength: null, // 加载历史消息前的历史记录长度
                changeStatusTimer: null,
                // 距底部多少像素内视为「在底部」（图片加载撑高内容时需更大容差）
                scrollBottomThreshold: 500,
            };
        },
        methods: {
            normalizeUrl,
            findChatById(chatId) {
                for (const group of this.cicadeStore.groupList) {
                if (group.chats && group.chats.length > 0) {
                    const chat = group.chats.find(c => c.chatId === chatId);
                    if (chat) {
                    return chat; // 直接返回 chat 对象
                    }
                }
                }
                return null; // 没找到
            },
          findChatStatusById(chatId) {
            for (const group of this.cicadeStore.groupList) {
              if (group.chats && group.chats.length > 0) {
                const chat = group.chats.find(c => c.chatId === chatId);
                if (chat) {
                  return chat; // 直接返回 chat 对象
                }
              }
            }
            return null; // 没找到
          },
            changeAutoTranslate(e){
                if (this.changeStatusTimer) {
                    clearTimeout(this.changeStatusTimer);
                }
                this.changeStatusTimer = setTimeout(() => {
                    this.$http({
                        url: '/client/updateChatSettings',
                        method: 'post',
                        data: {
                            accountId: this.cicadeStore.activeAccount?.accountId, // 获账号id
                            chatId: this.cicadeStore.activeChat?.chatId, //会话ID
                            autoTranslate: e,
                        }
                    })
                    .then(async() => {
                        await this.$store.dispatch('newLoadCicadeChat');
                        this.$message.success('修改成功');
                    })
                }, 300);
            },
            moveChatToTop() {
                let chatIdx = this.$store.getters.findChatIdx(this.chat);
                this.$store.commit('moveTop', chatIdx);
            },
            showSettingBox() {
                this.showChatSetting = true;
            },
            closeRefBox() {
                this.$refs.emoBox.close();
            },
            onCall(type) {
                if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
                    this.showPrivateVideo('voice');
                } else if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
                    this.showPrivateVideo('video');
                }
            },
            onSwitchReceipt() {
                this.isReceipt = !this.isReceipt;
                this.refreshPlaceHolder();
            },
            onImageSuccess(data, file) {
                let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
                msgInfo.content = JSON.stringify(data);
                
                if (data.originUrl) {
                    msgInfo.fileUrl = data.originUrl.replace(/^https?:\/\/[^/]+\/oss\//, "");
                } else if (data.thumbUrl) {
                    msgInfo.fileUrl = data.thumbUrl.replace(/^https?:\/\/[^/]+\/oss\//, "");
                } else if (data.partialUrl) {
                    msgInfo.fileUrl = data.partialUrl;
                } else {
                    console.error('图片上传返回数据缺少 URL 信息', data);
                    msgInfo.fileUrl = '';
                }
                
                // 设置 type 为字符串 'photo' 以便 ChatMessageItem 正确显示
                msgInfo.type = 'photo';
                msgInfo.receipt = this.isReceipt;
                
                // 像文件消息一样，直接发送完整对象而不是通过 sendMessageRequest
                let sendData = {
                    accountId: this.activeAccount.accountId,
                    chatId: this.cicadeStore.activeChat.chatId,
                    type: 'photo',
                    fileUrl: msgInfo.fileUrl,
                };
                this.$http({
                    url: '/client/send',
                    method: 'post',
                    data: sendData
                })
                .then((m) => {
                    msgInfo.loadStatus = 'ok';
                    msgInfo.id = m.id;
                    // 如果服务器返回了 fileUrl 或 type，使用服务器的值
                    if (m.fileUrl) {
                        msgInfo.fileUrl = m.fileUrl;
                    }
                    if (m.type) {
                        msgInfo.type = m.type;
                    }
                    this.isReceipt = false;
                    this.$store.commit('insertMessage', [msgInfo, this.chat]);
                    // 会话置顶
                    this.moveChatToTop();
                    // 滚动到底部
                    setTimeout(() => {
                        this.scrollToBottom();
                    }, 100);
                })
                .catch((e) => {
                    msgInfo.loadStatus = 'fail';
                    this.$store.commit('insertMessage', [msgInfo, this.chat]);
                });
            },
            onImageFail(e, file) {
                let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
                msgInfo.loadStatus = 'fail';
                this.$store.commit('insertMessage', [msgInfo, this.chat]);
            },
            onImageBefore(file) {
                // 被封禁提示
                if (this.isBanned) {
                    this.showBannedTip();
                    return;
                }
                let url = URL.createObjectURL(file);
                let data = {
                    originUrl: url,
                    thumbUrl: url
                };
                let msgInfo = {
                    id: 0,
                    tmpId: this.generateId(),
                    fileId: file.uid,
                    sendId: this.mine.id,
                    content: JSON.stringify(data),
                    sendTime: new Date().getTime(),
                    selfSend: true,
                    type: 1,
                    readedCount: 0,
                    loadStatus: 'loading',
                    status: this.$enums.MESSAGE_STATUS.UNSEND
                };
                // 借助file对象保存
                file.msgInfo = msgInfo;
            },
            onFileSuccess(res, file) {
                let data = {
                    accountId: file.msgInfo.accountId,
                    chatId: file.msgInfo.chatId,
                    type: res.resourceType,
                    fileUrl:res.url,
                    size: file.size
                }
                this.$http({
                        url: '/client/send',
                        method: 'post',
                        data,
                    })
                    .then((res) => {
                        this.isReceipt = false;
                        this.moveChatToTop();
                    }).finally(() => {
                        setTimeout(() => {
                            this.scrollToBottom();
                        }, 500);
                    });
            },
            onFileFail(e, file) {
                let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
                msgInfo.loadStatus = 'fail';
                this.$store.commit('insertMessage', [msgInfo, this.chat]);
            },
            onFileBefore(file) {
                // 被封禁提示
                if (this.isBanned) {
                    this.showBannedTip();
                    return;
                }
                let url = URL.createObjectURL(file);
                let data = {
                    name: file.name,
                    size: file.size,
                    url: url
                };
                let msgInfo = {
                    accountId: this.activeAccount.accountId,
                    chatId: this.chat.chatId,
                };
                // 会话置顶
                this.moveChatToTop();
                // 滚动到底部
                this.scrollToBottom();
                // 借助file对象透传
                file.msgInfo = msgInfo;
            },
            onCloseSide() {
                this.showSide = false;
            },
            onScrollToTop() {
                // 多展示10条信息
                this.showMinIdx = this.showMinIdx > 10 ? this.showMinIdx - 10 : 0;
            },
            onScroll(e) {
                const scrollElement = e.target;
                const scrollTop = scrollElement.scrollTop;
                const containerHeight = this.$refs.chatBox?.offsetHeight || 0;
                const div = this.getScrollElement();

                // 更新底部提示按钮显示状态
                this.showBottomTip = !(scrollTop + div.offsetHeight + this.scrollBottomThreshold > containerHeight);

                // 接近顶部时，减少显示的消息数量
                if (scrollTop < 30) {
                    this.showMinIdx = this.showMinIdx > 20 ? this.showMinIdx - 20 : 0;
                }

                // 触顶加载历史消息
                if (scrollTop === 0 && !this.isLoadingHistory) {
                    this.loadHistoryMessages();
                }
            },
            // 加载历史消息
            loadHistoryMessages() {
                this.oldScrollHeight = this.getScrollElement()?.scrollHeight;
                this.oldHistoryLength = this.cicadeStore.chatHistory.length;
                this.isLoadingHistory = true;
                this.$store.dispatch('getHistoryList')
                    .then(() => {
                        if (this.cicadeStore.chatHistory.length === this.oldHistoryLength) {
                            this.resetHistoryLoadingState();
                        }
                    })
                    .catch(() => {
                        this.resetHistoryLoadingState();
                    });
            },
            // 重置触顶加载状态
            resetHistoryLoadingState() {
                this.isLoadingHistory = false;
                this.oldScrollHeight = null;
                this.oldHistoryLength = null;
            },
            adjustScrollPosition() {
                if (!this.isLoadingHistory || !this.oldScrollHeight) {
                    return;
                }

                const scrollElement = this.getScrollElement();
                if (!scrollElement) {
                    this.resetHistoryLoadingState();
                    return;
                }

                const offsetHeight = scrollElement.scrollHeight - this.oldScrollHeight;

                if (offsetHeight > 0) {
                    scrollElement.scrollTop = offsetHeight;
                    requestAnimationFrame(() => {
                        if (scrollElement.scrollTop !== offsetHeight) {
                            scrollElement.scrollTop = offsetHeight;
                        }
                        this.resetHistoryLoadingState();
                    });
                } else {
                    this.resetHistoryLoadingState();
                }
            },
            showEmotionBox() {
                let width = this.$refs.emotion.offsetWidth;
                let left = this.$elm.fixLeft(this.$refs.emotion);
                let top = this.$elm.fixTop(this.$refs.emotion);
                this.$refs.emoBox.open({
                    x: left + width / 2,
                    y: top
                });
            },
            onEmotion(emoText) {
                this.$refs.chatInputEditor.insertEmoji(emoText);
            },
            showRecordBox() {
                this.showRecord = true;
            },
            closeRecordBox() {
                this.showRecord = false;
            },
            showPrivateVideo(mode) {
                // 检查是否被封禁
                if (this.isBanned) {
                    this.showBannedTip();
                    return;
                }

                let rtcInfo = {
                    mode: mode,
                    isHost: true,
                    friend: this.friend
                };
                // 通过home.vue打开单人视频窗口
                this.$eventBus.$emit('openPrivateVideo', rtcInfo);
            },
            onGroupVideo() {
                // 检查是否被封禁
                if (this.isBanned) {
                    this.showBannedTip();
                    return;
                }
                // 邀请成员发起通话
                let ids = [this.mine.id];
                let maxChannel = this.$store.state.configStore.webrtc.maxChannel;
                this.$refs.rtcSel.open(maxChannel, ids, ids);
            },
            onInviteOk(members) {
                if (members.length < 2) {
                    return;
                }
                let userInfos = [];
                members.forEach((m) => {
                    userInfos.push({
                        id: m.userId,
                        nickName: m.showNickName,
                        headImage: m.headImage,
                        isCamera: false,
                        isMicroPhone: true
                    });
                });
                let rtcInfo = {
                    isHost: true,
                    groupId: this.group.id,
                    inviterId: this.mine.id,
                    userInfos: userInfos
                };
                // 通过home.vue打开多人视频窗口
                this.$eventBus.$emit('openGroupVideo', rtcInfo);
            },
            showHistoryBox() {
                this.showHistory = true;
            },
            closeHistoryBox() {
                this.showHistory = false;
            },
            onSendRecord(data) {
                // 检查是否被封禁
                if (this.isBanned) {
                    this.showBannedTip();
                    return;
                }
                let msgInfo = {
                    content: JSON.stringify(data),
                    type: 3,
                    receipt: this.isReceipt
                };
                // 填充对方id
                this.fillTargetId(msgInfo, this.chat.targetId);
                this.sendMessageRequest(msgInfo).then(async (m) => {
                    m.selfSend = true;
                    this.$store.commit('insertMessage', [m, this.chat]);
                    // 会话置顶
                    this.moveChatToTop();
                    // 保持输入框焦点
                    this.$refs.chatInputEditor.focus();
                    // 滚动到底部
                    this.scrollToBottom();
                    // 关闭录音窗口
                    this.showRecord = false;
                    this.isReceipt = false;
                    this.refreshPlaceHolder();
                });
            },
            fillTargetId(msgInfo, targetId) {
                if (this.chat.type == 'GROUP') {
                    msgInfo.groupId = targetId;
                } else {
                    msgInfo.recvId = targetId;
                }
            },
            unescapeHtml(str) {
                if (!str) return '';
                return str
                    .replace(/&amp;/g, '&')
                    .replace(/&lt;/g, '<')
                    .replace(/&gt;/g, '>')
                    .replace(/&quot;/g, '"')
                    .replace(/&#39;/g, "'");
            },
            notifySend() {
                this.$refs.chatInputEditor.submit();
            },
            async sendMessage(fullList) {
                this.resetEditor();
                // this.readedMessage();
                // 检查是否被封禁
                if (this.isBanned) {
                    this.showBannedTip();
                    return;
                }
                let sendText = this.isReceipt ? '【回执消息】' : '';
                let promiseList = [];
                for (let i = 0; i < fullList.length; i++) {
                    let msg = fullList[i];
                    // 只对文本类型的消息进行 HTML 转义处理
                    if (msg.type === 'text' && typeof msg.content === 'string') {
                        msg.content = this.unescapeHtml(msg.content);
                    }
                    switch (msg.type) {
                        case 'text':
                            // sendText +
                            await this.sendTextMessage(msg.content, msg.atUserIds);
                            break;
                        case 'image':
                            await this.sendImageMessage(msg.content.file);
                            break;
                        case 'file':
                            await this.sendFileMessage(msg.content.file);
                            break;
                    }
                }
            },
            sendImageMessage(file) {
                this.loadingImg = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
                return new Promise((resolve, reject) => {
                    this.onImageBefore(file);
                    let formData = new FormData();
                    formData.append('file', file);
                    this.$http
                        .post('/image/upload', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                        .then((data) => {
				            this.loadingImg && this.loadingImg.close();
                            this.onImageSuccess(data, file);
                            resolve();
                        })
                        .catch((res) => {
				            this.loadingImg && this.loadingImg.close();
                            this.onImageFail(res, file);
                            reject();
                        });
                    this.$nextTick(() => this.$refs.chatInputEditor.focus());
                    this.scrollToBottom();
                });
            },
            sendTextMessage(sendText, atUserIds) {
                return new Promise((resolve, reject) => {
                    if (!sendText.trim()) {
                        reject();
                    }
                    let msgInfo = {
                        content: sendText,
                        type: 0
                    };
                    // 填充对方id
                    this.fillTargetId(msgInfo, this.chat.targetId);
                    // 被@人员列表
                    if (this.chat.type == 'GROUP') {
                        msgInfo.atUserIds = atUserIds;
                        msgInfo.receipt = this.isReceipt;
                    }
                    this.lockMessage = true;
                    this.sendMessageRequest(msgInfo)
                        .then((m) => {
                            // 会话置顶
                            this.moveChatToTop();
                            // 延迟滚动，等待消息通过WebSocket推送并渲染
                            setTimeout(() => {
                                this.scrollToBottom();
                            }, 100);
                        })
                        .finally(() => {
                            // 解除锁定
                            this.isReceipt = false;
                            resolve();
                        });
                });
            },
            sendFileMessage(file) {
                return new Promise((resolve, reject) => {
                    let check = this.$refs.fileUpload.beforeUpload(file);
                    if (check) {
                        this.$refs.fileUpload.onFileUpload({ file });
                    }
                });
            },
            deleteMessage(msgInfo) {
                this.$confirm('确认删除消息?', '删除消息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.commit('deleteMessage', msgInfo);
                });
            },
            recallMessage(msgInfo) {
                this.$confirm('确认撤回消息?', '撤回消息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let url = `/message/${this.chat.type.toLowerCase()}/recall/${msgInfo.id}`;
                    this.$http({
                        url: url,
                        method: 'delete'
                    }).then(() => {
                        this.$message.success('消息已撤回');
                        msgInfo = JSON.parse(JSON.stringify(msgInfo));
                        msgInfo.type = 10;
                        msgInfo.content = '你撤回了一条消息';
                        msgInfo.status = this.$enums.MESSAGE_STATUS.RECALL;
                        this.$store.commit('insertMessage', [msgInfo, this.chat]);
                    });
                });
            },
            readedMessage() {
                if (this.chat.unreadCount == 0) {
                    return;
                }
                this.$store.commit('resetUnreadCount', this.chat);
                if (this.chat.type == 'GROUP') {
                    var url = `/message/group/readed?groupId=${this.chat.targetId}`;
                } else {
                    url = `/message/private/readed?friendId=${this.chat.targetId}`;
                }
                this.$http({
                    url: url,
                    method: 'put'
                }).then(() => {});
            },
            loadReaded(fId) {
                this.$http({
                    url: `/message/private/maxReadedId?friendId=${fId}`,
                    method: 'get'
                }).then((id) => {
                    this.$store.commit('readedMessage', {
                        friendId: fId,
                        maxId: id
                    });
                });
            },
            loadGroup(groupId) {
                this.$http({
                    url: `/group/find/${groupId}`,
                    method: 'get'
                }).then((group) => {
                    this.group = group;
                    this.$store.commit('updateChatFromGroup', group);
                    this.$store.commit('updateGroup', group);
                });

                this.$http({
                    url: `/group/members/${groupId}`,
                    method: 'get'
                }).then((groupMembers) => {
                    this.groupMembers = groupMembers;
                });
            },
            loadFriend(friendId) {
                // 获取对方最新信息
                this.$http({
                    url: `/user/find/${friendId}`,
                    method: 'get'
                }).then((friend) => {
                    this.friend = friend;
                    this.$store.commit('updateChatFromFriend', friend);
                    this.$store.commit('updateFriend', friend);
                });
            },
            showName(msgInfo) {
                if (this.chat.type == 'GROUP') {
                    let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
                    return member ? member.showNickName : '';
                } else {
                    return msgInfo.sendId == this.mine.id ? this.mine.nickName : this.chat.showName;
                }
            },
            headImage(msgInfo) {
                if (this.chat.type == 'GROUP') {
                    let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
                    return member ? member.headImage : '';
                } else {
                    return msgInfo.sendId == this.mine.id ? this.mine.headImageThumb : this.chat.headImage;
                }
            },
            resetEditor() {
                this.$nextTick(() => {
                    this.$refs.chatInputEditor.clear();
                    this.$refs.chatInputEditor.focus();
                });
            },
            // 获取滚动容器元素
            getScrollElement() {
                return document.getElementById('chatScrollBox');
            },
            // 判断消息是否是自己发送的
            isSelfSendMessage(message) {
                if (message.platform === 'customer') {
                    return message.senderId != message.chatId;
                }
                if (message.platform === 'facebook_api') {
                    const chatId = message.chatIdStr || message.chatId;
                    return message.senderId != chatId;
                }
                return message.senderId == this.activeAccount[this.cicadeStore.sendIdKey];
            },
            // 处理新消息到达
            handleNewMessage(lastMessage) {
                const isSelfSend = this.isSelfSendMessage(lastMessage);

                if (isSelfSend || this.isNearBottom()) {
                    this.waitForDOMUpdate(() => this.scrollToBottom());
                } else {
                    this.isHaveNewMessage = true;
                    this.showBottomTip = true;
                }
            },
            // 检查是否在底部附近
            isNearBottom() {
                const div = this.getScrollElement();
                if (!div) return false;
                const { scrollTop, scrollHeight, clientHeight } = div;
                return scrollTop + clientHeight + this.scrollBottomThreshold >= scrollHeight;
            },
            // 滚动到底部
            scrollToBottom() {
                this.waitForDOMUpdate(() => {
                    const div = this.getScrollElement();
                    if (div) {
                        div.scrollTop = div.scrollHeight + 1000;
                        requestAnimationFrame(() => {
                            div.scrollTop = div.scrollHeight;
                            this.isHaveNewMessage = false;
                            this.showBottomTip = false;
                        });
                    }
                });
            },
            // 等待DOM更新的工具方法
            waitForDOMUpdate(callback) {
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        this.$nextTick(callback);
                    });
                });
            },
            refreshPlaceHolder() {
                if (this.isReceipt) {
                    this.placeholder = '【回执消息】';
                } else if (this.$refs.editBox && this.$refs.editBox.innerHTML) {
                    this.placeholder = '';
                } else {
                    this.placeholder = '聊点什么吧~';
                }
            },
            sendMessageRequest(msgInfo) {
                return new Promise((resolve, reject) => {
                    // 请求入队列，防止请求"后发先至"，导致消息错序
                    this.reqQueue.push({ msgInfo, resolve, reject });
                    this.processReqQueue();
                });
            },
            processReqQueue() {
                if (this.reqQueue.length && !this.isSending) {
                    this.isSending = true;
                    const reqData = this.reqQueue.shift();
                    this.$http({
                        url: '/client/send',
                        method: 'post',
                        data: {
                            accountId: this.activeAccount.accountId,
                            chatId: this.cicadeStore.activeChat.chatId,
                            message: reqData.msgInfo.content
                        }
                    })
                        .then((res) => {
                            reqData.resolve(res);
                        })
                        .catch((e) => {
                            reqData.reject(e);
                        })
                        .finally(() => {
                            this.isSending = false;
                            // 发送下一条请求
                            this.processReqQueue();
                        });
                }
            },
            showBannedTip() {
                let msgInfo = {
                    tmpId: this.generateId(),
                    sendId: this.mine.id,
                    sendTime: new Date().getTime(),
                    type: this.$enums.MESSAGE_TYPE.TIP_TEXT
                };
                if (this.chat.type == 'PRIVATE') {
                    msgInfo.recvId = this.mine.id;
                    msgInfo.content = '该用户已被管理员封禁,原因:' + this.friend.reason;
                } else {
                    msgInfo.groupId = this.group.id;
                    msgInfo.content = '本群聊已被管理员封禁,原因:' + this.group.reason;
                }
                this.$store.commit('insertMessage', [msgInfo, this.chat]);
            },
            generateId() {
                // 生成临时id
                return String(new Date().getTime()) + String(Math.floor(Math.random() * 1000));
            }
        },
        computed: {
            mine() {
                return this.$store.state.userStore.userInfo;
            },
            cicadeStore() {
                return this.$store.state.cicadeStore;
            },
            activeAccount() {
                return this.$store.state.cicadeStore.activeAccount;
            },
            title() {
                let title = this.chat.showName;
                if (this.chat.type == 'GROUP') {
                    let size = this.groupMembers.filter((m) => !m.quit).length;
                    title += `(${size})`;
                }
                return title;
            },
            unreadCount() {
                return this.chat.unreadCount;
            },
            isBanned() {
                return (this.chat.type == 'PRIVATE' && this.friend.isBanned) || (this.chat.type == 'GROUP' && this.group.isBanned);
            }
        },
        watch: {
            chat: {
                handler(newChat, oldChat) {
                    if (newChat) {
                        // 加载消息
                        this.loading = true;
                        this.$store.dispatch('loadCicadeChatHistory', () => {
                            this.loading = false;
                            this.scrollToBottom();
                            setTimeout(() => {
                                this.scrollToBottom();
                            }, 300);
                        });
                        this.resetEditor();
                    }
                },
                immediate: true
            },
            'cicadeStore.chatHistory': {
                handler(newHistory, oldHistory) {
                    if (!oldHistory || newHistory.length === 0) return;

                    // 当历史消息加载完成，且是顶部加载时，调整滚动位置
                    if (this.isLoadingHistory && newHistory.length > oldHistory.length) {
                        const oldFirstId = oldHistory[0]?.id;
                        const newFirstId = newHistory[0]?.id;
                        if (oldFirstId !== newFirstId) {
                            this.waitForDOMUpdate(() => this.adjustScrollPosition());
                        } else if (newHistory.length === this.oldHistoryLength) {
                            this.resetHistoryLoadingState();
                        }
                    }
                    // 当新消息添加到末尾时（发送消息或接收消息）
                    else if (newHistory.length > oldHistory.length && !this.isLoadingHistory) {
                        const oldLastId = oldHistory[oldHistory.length - 1]?.id;
                        const newLastId = newHistory[newHistory.length - 1]?.id;
                        if (newLastId && oldLastId !== newLastId) {
                            this.$nextTick(() => {
                                this.handleNewMessage(newHistory[newHistory.length - 1]);
                            });
                        }
                    }
                },
                deep: false
            }
        },
        mounted() {
            let div = document.getElementById('chatScrollBox');
            if (div) {
                div.addEventListener('scroll', this.onScroll);
            }
        }
    };
</script>

<style lang="scss">
    .chat-box {
        flex: 1;
        position: relative;
        // width: 100%;
        background: #fff;

        .el-header {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0 12px;
            line-height: 50px;
            font-size: var(--im-font-size-larger);
            border-bottom: var(--im-border);

            .btn-side {
                position: absolute;
                right: 20px;
                line-height: 50px;
                font-size: 20px;
                cursor: pointer;
                color: var(--im-text-color-light);
            }
        }

        .im-chat-main {
            padding: 0;
            background-color: #f7f7f7;
            position: relative;

            .chat-bottom-tip {
                cursor: pointer;
                float: right;
                margin-right: 120px;
                position: sticky;
                bottom: 20px;
                right: 20px;
                height: 32px;
                width: 32px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                color: var(--im-text-color-light);
                background-color: #fff;
                border: var(--im-border);
                border-radius: 50%;
            }

            .im-chat-box {
                > ul {
                    padding: 0 20px;

                    li {
                        list-style-type: none;
                    }
                }
            }
        }

        .im-chat-footer {
            display: flex;
            flex-direction: column;
            padding: 0;

            .chat-tool-bar {
                display: flex;
                position: relative;
                width: 100%;
                height: 36px;
                text-align: left;
                box-sizing: border-box;
                border-top: var(--im-border);
                padding: 4px 2px 2px 8px;

                > div {
                    font-size: 22px;
                    cursor: pointer;
                    line-height: 30px;
                    width: 30px;
                    height: 30px;
                    text-align: center;
                    border-radius: 2px;
                    margin-right: 8px;
                    color: #999;
                    transition: 0.3s;

                    &.chat-tool-active {
                        font-weight: 600;
                        color: var(--im-color-primary);
                        background-color: #ddd;
                    }
                }

                > div:hover {
                    color: #333;
                }
            }

            .send-content-area {
                position: relative;
                display: flex;
                flex-direction: column;
                height: 100%;
                background-color: white !important;

                .send-text-area {
                    box-sizing: border-box;
                    padding: 5px;
                    width: 100%;
                    flex: 1;
                    resize: none;
                    font-size: 16px;
                    outline: none;

                    text-align: left;
                    line-height: 30px;

                    &:before {
                        content: attr(placeholder);
                        color: gray;
                    }

                    .at {
                        color: blue;
                        font-weight: 600;
                    }

                    .receipt {
                        color: darkblue;
                        font-size: 15px;
                        font-weight: 600;
                    }

                    .emo {
                        width: 30px;
                        height: 30px;
                        vertical-align: bottom;
                    }
                }

                .send-image-area {
                    text-align: left;
                    border: #53a0e7 solid 1px;

                    .send-image-box {
                        position: relative;
                        display: inline-block;

                        .send-image {
                            max-height: 180px;
                            border: 1px solid #ccc;
                            border-radius: 2%;
                            margin: 2px;
                        }

                        .send-image-close {
                            position: absolute;
                            padding: 3px;
                            right: 7px;
                            top: 7px;
                            color: white;
                            cursor: pointer;
                            font-size: 15px;
                            font-weight: 600;
                            background-color: #aaa;
                            border-radius: 50%;
                            border: 1px solid #ccc;
                        }
                    }
                }

                .send-btn-area {
                    padding: 10px;
                    position: absolute;
                    bottom: 4px;
                    right: 6px;
                }
            }
        }

        .chat-group-side-box {
            border-left: var(--im-border);
            //animation: rtl-drawer-in .3s 1ms;
        }
    }
</style>
